import { HIDE_WILDIX_MODAL, SHOW_WILDIX_MODAL } from './actionTypes';

export const openWildixModal = ({ component, id, props }) => {
    return {
        type: SHOW_WILDIX_MODAL,
        component,
        id,
        props
    };
};

export const hideWildixModal = () => {
    return {
        type: HIDE_WILDIX_MODAL
    };
};